import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import Image from "next/image";
import styled, { css } from "styled-components";
import {
  BRANDS_ARRAY, BRANDS_MOTO_ARRAY,
  MODELS_ARRAY, PRICE_ARRAY
} from "@motorata/base-ui.data";
import Modal, { EmptyModal } from "@motorata/base-ui.components.molecules.modal";
import { H1, P } from "@motorata/base-ui.components.atoms.typography";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import Select, { RangeSelect } from "@motorata/base-ui.components.atoms.select";
import Button, { IconButton } from "@motorata/base-ui.components.atoms.button";
import Link from "@motorata/next.components.atoms.link";
import RadioSlider from "@motorata/base-ui.components.atoms.radio-slider";
import { useRouter } from "next/navigation";
import { default as ReactSlick } from "react-slick";
import Icon from "@motorata/base-ui.components.atoms.icon";
import { useWindowSize } from "../../hooks/useWindowSize";
import FiltersComponents from "../../components/shared/FiltersComponents";
import { FilterContext } from "@/providers/FilterProvider";
import { GET } from "@/services/GET";
import { convertOffersFiltersObjectToServiceFilters } from "@/helpers/paramsOffers.helper";

const MainSlider = () => {
  const mainRef = useRef();
  const [show, setShow] = useState(true);
  const [index, setIndex] = useState(0);
  const [showFullScreen, setShowFullScreen] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: "linear"
  };

  const handleChangeSlide = useCallback(index => {
    // @ts-ignore
    mainRef.current?.slickGoTo(index);
    setIndex(index);
  }, []);

  return (
    <>
      <div className="main_slider">
        <CirclesWrapper></CirclesWrapper>
        <SliderWrapper>
          <SliderContent>
            <VideoWrapper>
              <iframe src="https://player.vimeo.com/video/887040469?background=1" frameBorder={0} width="auto"
                      height="100%"></iframe>
              <VideoButton onClick={() => setShowFullScreen(true)}>
                <Icon height="35px" width="35px" icon="play" color="white" />
              </VideoButton>
            </VideoWrapper>
          </SliderContent>
        </SliderWrapper>
        {/*{*/}
        {/*  show &&*/}
        {/*  <SliderWrapper>*/}
        {/*    <SliderContent>*/}
        {/*      <ReactSlick*/}
        {/*        ref={mainRef}*/}
        {/*        beforeChange={(_, newIndex) => handleChangeSlide(newIndex)}*/}
        {/*        initialSlide={index}*/}
        {/*        {...settings}*/}
        {/*      >*/}
        {/*        <VideoWrapper>*/}
        {/*          <iframe src="https://player.vimeo.com/video/887040469?background=1" frameBorder={0} width="auto"*/}
        {/*                  height="100%"></iframe>*/}
        {/*          <VideoButton onClick={() => setShowFullScreen(true)}>*/}
        {/*            <Icon height="35px" width="35px" icon="play" color="white" />*/}
        {/*          </VideoButton>*/}
        {/*        </VideoWrapper>*/}
        {/*        <SlideWrapper>*/}
        {/*          <Image*/}
        {/*            priority={true}*/}
        {/*            layout="fill"*/}
        {/*            alt="Głowna grafika na stronie głównej"*/}
        {/*            src="/images/slider/1.png"*/}
        {/*          />*/}
        {/*        </SlideWrapper>*/}
        {/*        <SlideWrapper>*/}
        {/*          <Image*/}
        {/*            priority={true}*/}
        {/*            layout="fill"*/}
        {/*            alt="Głowna grafika na stronie głównej"*/}
        {/*            src="/images/slider/2.png"*/}
        {/*          />*/}
        {/*        </SlideWrapper>*/}
        {/*        <SlideWrapper>*/}
        {/*          <Image*/}
        {/*            priority={true}*/}
        {/*            layout="fill"*/}
        {/*            alt="Głowna grafika na stronie głównej"*/}
        {/*            src="/images/slider/3.png"*/}
        {/*          />*/}
        {/*        </SlideWrapper>*/}
        {/*        <SlideWrapper>*/}
        {/*          <Image*/}
        {/*            priority={true}*/}
        {/*            layout="fill"*/}
        {/*            alt="Głowna grafika na stronie głównej"*/}
        {/*            src="/images/audi-q8.png"*/}
        {/*          />*/}
        {/*        </SlideWrapper>*/}
        {/*      </ReactSlick>*/}
        {/*    </SliderContent>*/}
        {/*    <SliderDotsWrapper>*/}
        {/*      <SliderDot active={index === 0} onClick={() => handleChangeSlide(0)} />*/}
        {/*      <SliderDot active={index === 1} onClick={() => handleChangeSlide(1)} />*/}
        {/*      <SliderDot active={index === 2} onClick={() => handleChangeSlide(2)} />*/}
        {/*      <SliderDot active={index === 3} onClick={() => handleChangeSlide(3)} />*/}
        {/*    </SliderDotsWrapper>*/}
        {/*  </SliderWrapper>*/}
        {/*}*/}
      </div>
      <MobileVideoWrapper>
        <MobileVideoContent>
          <iframe src="https://player.vimeo.com/video/893232899?background=1" frameBorder={0} width="100%"
                  height="100%"></iframe>
          <VideoButton onClick={() => setShowFullScreen(true)}>
            <Icon height="35px" width="35px" icon="play" color="white" />
          </VideoButton>
        </MobileVideoContent>
      </MobileVideoWrapper>
      <EmptyModal show={showFullScreen} setShow={setShowFullScreen}>
        <FullScreenVideoWrapper>
          <iframe src="https://player.vimeo.com/video/893232899" frameBorder={0} width="100%" height="auto"></iframe>
        </FullScreenVideoWrapper>
      </EmptyModal>
    </>
  );
};

const MainSection = () => {
  const router = useRouter();

  const { width } = useWindowSize();
  const { filters, onChangeNoRedirect, generateURL } = useContext(FilterContext);
  const [showFilters, setShowFilters] = useState(false);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const data = await GET.getOffersCount(convertOffersFiltersObjectToServiceFilters(filters));
        setData(data);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [filters]);

  const handleChangeCurrentPage = () => {
    router.push(generateURL());
  };

  return (
    <>
      <Wrapper className="main background">
        <Box className="main_form">
          <StyledH1 fontWeight="extraBold">
            Znajdź z nami swój <span>samochód marzeń</span>
          </StyledH1>
          <P>
            Na naszej platformie znajdziesz dziesiątki samochodów dostępnych w leasingu, pożyczce
            leasingowej lub kredycie prosto od dealerów oraz brokerów.
          </P>
          <Box marginTop="L">
            <RadioSlider
              name="productType"
              width="100%"
              value={filters.productType}
              onChange={onChangeNoRedirect}
              options={[
                ["Wszystkie", "all"],
                ["Osobowe", "car"],
                ["Dostawcze", "truck"],
                ["Motocykle", "motorbikes"]
              ]}
              columnBreakpoint={500}
            />
            <InputFiltersWrapper showModel={filters.productType === "all" || filters.productType === "car"}>
              <Select
                height="100%"
                name="brand"
                label="Marka"
                value={filters.brand}
                background="white"
                onChange={e => onChangeNoRedirect(e)}
                options={filters.productType === "motorbikes" ? BRANDS_MOTO_ARRAY : BRANDS_ARRAY}
              />
              {
                (filters.productType === "all" || filters.productType === "car") &&
                <Select
                  name="model"
                  background="white"
                  label="Model"
                  value={filters.model}
                  onChange={e => onChangeNoRedirect(e)}
                  options={MODELS_ARRAY[filters.brand]}
                />
              }
              <RangeSelect
                name="price"
                value={filters.price}
                labels={["Cena od", "Cena do"]}
                onChange={onChangeNoRedirect}
                background="white"
                options={[PRICE_ARRAY, PRICE_ARRAY]}
              />
              {width < 850 ? (
                <Button
                  type="secondary"
                  onClick={() => setShowFilters(true)}
                  width="100%"
                  height="58px"
                  icon="filters"
                  background="white"
                >
                  Zaawansowane filtrowanie
                </Button>
              ) : (
                <IconButton
                  onClick={() => setShowFilters(true)}
                  padding="0"
                  icon="filters"
                  hoverColor="primary"
                  background="white"
                  style={{
                    width: 58,
                    height: 58,
                    borderRadius: 3
                  }}
                />
              )}
            </InputFiltersWrapper>
            <ButtonFiltersWrapper>
              <Link
                type="secondary"
                href="/oferty"
                width="100%"
                background="white"
                height="58px"
              >
                Wszystkie oferty
              </Link>
              <Button
                width="100%"
                height="58px"
                loading={loading}
                onClick={handleChangeCurrentPage}
              >
                Pokaż oferty{data ? ` (${data})` : ""}
              </Button>
            </ButtonFiltersWrapper>
          </Box>
        </Box>
        <MainSlider />
      </Wrapper>
      <Modal
        title="Zaawansowane filtry"
        type="side"
        show={showFilters}
        setShow={setShowFilters}
        maxWidth="500px"
      >
        <FiltersComponents onChange={onChangeNoRedirect} />
        <ButtonWrapper>
          <Button
            width="100%"
            loading={loading}
            onClick={handleChangeCurrentPage}
          >
            Pokaż oferty{data ? ` (${data})` : ""}
          </Button>
        </ButtonWrapper>
      </Modal>
    </>
  );
};

export default MainSection;

const FullScreenVideoWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100vw;
  max-width: 900px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 56.25%;
  overflow: hidden;

  iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`;

const VideoButton = styled.button`
  border-radius: 70px;
  border: none;
  width: 100px;
  height: 100px !important;
  background: rgba(0, 0, 0, 0.4);
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileVideoWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`;

const MobileVideoContent = styled.div`
  background: ${({ theme }) => theme.color.primary};
  padding-top: 56.25%;
  border-radius: 25px;
  overflow: hidden;
  margin-top: ${({ theme }) => theme.space.XL};

  iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 25px;
    overflow: hidden;
  }
`;

const VideoWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border: 5px solid ${({ theme }) => theme.color.primary};
  border-radius: 25px;
  height: 100%;
  width: 100%;

  iframe {
    position: absolute;
    left: 50%;
    top: 0;
    pointer-events: none;
    width: calc(33vw * 1.78);
    height: 33vw;
    transform: translateX(-50%);
  }
`;

const SlideWrapper = styled.div`
    //height: calc(100% - 10px - (${({ theme }) => theme.space.S}*2));
  height: 100%;
  width: 100%;
  transform: translateX(-10%);
`;

const SliderDot = styled(Box)<{
  active: boolean
}>`
  height: 9px;
  background: ${({ theme }) => theme.color.background};
  width: 100%;
  margin: ${({ theme }) => theme.space.S} 0;
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.color.background};
  cursor: pointer;
  transition: background-color 0.3s;


  ${({ active }) => active && css`
    background: ${({ theme }) => theme.color.primary};
  `}
`;

const SliderDotsWrapper = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: stretch;
  grid-gap: ${({ theme }) => theme.space.XS};
  padding: 0 ${({ theme }) => theme.space.S};
`;

const SliderContent = styled(Box)`
  position: relative;
  height: 100%;
  width: 100%;

  .slick-list {
    overflow: visible;
  }

  .slick-slide {
    z-index: 0;

    &.slick-active {
      z-index: 1;
    }
  }

  .slick-slider {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;

    div {
      height: 100%;
      position: relative;

      span {
        width: 100% !important;
        height: 100% !important;
      }

      img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain;
      }
    }
  }
`;

const SliderWrapper = styled(Box)`
  height: 100%;
  width: 100%;
  position: relative;

  @media (max-width: 1200px) {
    display: none;
  }
`;

const Wrapper = styled(Box)`
  justify-content: space-between;
`;

const StyledH1 = styled(H1)`
  display: block;
  font-size: 55px;
  line-height: 65px;
  max-width: 600px;
  font-weight: ${({ theme }) => theme.font.extraBold};

  span {
    font-size: 55px;
    line-height: 65px;
    font-weight: inherit;
    color: ${({ theme }) => theme.color.primary};
  }

  @media (max-width: 600px) {
    font-size: 35px;
    line-height: 40px;

    span {
      font-size: 35px;
      line-height: 40px;
    }
  }
`;

const ButtonFiltersWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.XS};

  @media (min-width: 850px) {
    grid-template-columns: 1fr 1fr 58px;
    > :nth-child(2) {
      grid-column-start: 2;
      grid-column-end: 4;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const InputFiltersWrapper = styled(Box)<{
  showModel: boolean
}>`
  display: grid;
  grid-template-columns: 1fr 2fr 58px;
  grid-gap: ${({ theme }) => theme.space.XS};
  margin: ${({ theme }) => theme.space.XS} 0;

  @media (max-width: 850px) {
    grid-template-columns: 1fr 1fr;
  }

  ${({ showModel }) => showModel && css`
    grid-template-columns: 1fr 1fr 2fr 58px;
  `};

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ButtonWrapper = styled(Box)`
  padding: 20px;
  padding-top: 0;
  display: block;
  position: sticky;
  bottom: 0;
  margin-top: ${({ theme }) => theme.space.S};
`;

const CirclesWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  border-radius: 25px;

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: -35%;
    top: -35%;
    width: 80%;
    height: 80%;
    background: ${({ theme }) => theme.color.primaryDarker};
    border-radius: 50%;
    opacity: 0.3;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    right: -35%;
    bottom: -35%;
    width: 80%;
    height: 80%;
    background: ${({ theme }) => theme.color.primaryDarker};
    border-radius: 50%;
    opacity: 0.3;
  }
`;
